import {
  getActiveUser,
  navigate,
  sendGetRequest,
  formatDate,
  sendDeleteRequest,
  allowedOperations,
} from "../utils/utils";
import DataListWithSearch from "./component/@list/list-search";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";

const getTableHead = () => {
  return [
    { id: "createdAt", label: "Created On", alignRight: false },
    { id: "day", label: "Day of the week", alignRight: false },
    { id: "title", label: "Title", alignRight: false },
    { id: "videoPlayed", label: "Videos", align: "center" },
    { id: "musicListened", label: "Songs", align: "center" },
    { id: "gamesPlayed", label: "Games", align: "center" },
    { id: "booksRead", label: "Books", align: "center" },
    { id: "timeSpent", label: "Minutes", align: "center" },
    { id: "uniqueUsers", label: "Users", align: "center" },
    { id: "attempts", label: "Attempts", align: "center" },
    { id: "completionRate", label: "Completion Rate", align: "center" },
    { id: "_", label: "", alignRight: false },
  ];
};

const startEdit = (uuid) =>
  navigate(
    `${AppRoutes.appSettings}/${AppRoutes.challenge}${
      uuid ? `?uuid=${uuid}` : ""
    }`,
    true,
  );

const DailyChallenges = () => {
  const loggedUser = getActiveUser();
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const { canEdit, canDelete, canCreate } = allowedOperations();

  const orderByWeekDay = (data) => {
  // Define the correct order of days starting with Monday
  const dayOrder = {
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6,
    'Sunday': 7
  };
  return data
    .filter(item => dayOrder.hasOwnProperty(item.day))
    .sort((a, b) => dayOrder[a.day] - dayOrder[b.day]);
};

  const userOptions = [
    canDelete
      ? {
          icon: "delete",
          value: "delete",
          label: "Delete",
          onClick: (value, selected) => {
            onLoading(true);
            Promise.all(
              selected.map((uuid) => sendDeleteRequest("challenges", uuid)),
            ).then((response) => {
              executeFetch();
            });
          },
        }
      : null,
    canEdit
      ? {
          icon: "edit",
          value: "edit",
          label: "Edit",
          onClick: (value, selected) => startEdit(selected[0]),
        }
      : null,
  ].filter(Boolean);
  const filterOptions = [];

  const executeFetch = () => {
    sendGetRequest(
      "challenges",
      (loading) => onLoading(loading),
      (data) => setDataList(data),
    );
  };

  useEffect(
    () => executeFetch(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loggedUser.email],
  );

  return (
    <div>
      <DataListWithSearch
        sectionTitle="Daily Challenges"
        createNewLabel={loggedUser.active && canCreate ? "Add Challenge" : null}
        data={orderByWeekDay(dataList)}
        primaryKey="uuid"
        filterColumn={"createdOn"}
        emptyIcon="puzzle"
        avatarKey="uuid"
        loading={loading}
        onCreateNewItem={() => startEdit()}
        headers={getTableHead()}
        onBack={() => navigate(`${AppRoutes.appSettings}`, true)}
        rowData={(data) => {
          const _entries = [
            { value: formatDate(data.createdAt), width: 200 },
            { value: data.day, width: 160 },
            { value: data.title, width: 180 },
            { value: data.videoPlayed, width: 100, align: "center", tooltip : "Number of videos to be played by users in the challenge" },
            { value: data.musicListened, width: 100, align: "center", tooltip : "Number of songs to be listened by users in the challenge" },
            { value: data.booksRead, width: 100, align: "center", tooltip : "Number of books to be read by users in the challenge" },
            { value: data.gamesPlayed, width: 100, align: "center" , tooltip : "Number of games to be played by users in the challenge"},
            { value: data.timeSpent, width: 100, align: "center", tooltip : "Total time to be spent by users on the challenge in minutes" },
            { value: data.uniqueUsers, width: 100, align: "center", tooltip : "Number of unique users who attempted the challenge" },
            { value: data.attempts, width: 100, align: "center", tooltip : "Number of attempts made by users to complete the challenge" },
            {
              value: data.completionRate,
              width: 140,
              align: "center",
              tooltip : "Percentage of attempts that resulted in successful completion of the challenge",
            },
          ];
          return {
            exclude: [],
            entries: _entries,
          };
        }}
        selectionOptions={userOptions.filter(
          (option) => option.value !== "edit",
        )}
        filterOptions={filterOptions}
        optionItems={userOptions}
      />
    </div>
  );
};

export default DailyChallenges;
